import './ToggleBar.scss';

import classnames from 'classnames';
import { array, bool, func, number, oneOfType, string } from 'prop-types';
import React from 'react';

const ToggleBar = ({ className, label, onChange, options, selection }) => (
  <div
    className={`${className} toggle-bar-select-group e2e-group-by-select-toggle-bar`}>
    {label && <p className="toggle-bar-select-label">{label}</p>}
    <div className="toggle-bar-toggle">
      {options.map(({ label, value }, index) => (
        <div key={index} className="option-element">
          <label
            className={classnames({ checked: selection === value })}
            htmlFor={`${className}-${value}`}>
            <input
              type="radio"
              className="option-input radio"
              name="radio-option"
              id={`${className}-${value}`}
              value={value}
              onChange={onChange}
            />
            {label}
          </label>
        </div>
      ))}
    </div>
  </div>
);

ToggleBar.propTypes = {
  className: string,
  label: string,
  onChange: func.isRequired,
  options: array.isRequired,
  selection: oneOfType([bool, number, string]).isRequired
};

ToggleBar.defaultProps = {
  className: ''
};

export default ToggleBar;
